import { Button, Paper, Stack } from '@mui/material'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import shared from '@/components/Settings/settingsShared.module.scss'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'
import { GeneralSettingsSection } from './GeneralSettingsSection'

/**
 * @param {{ paperFirst: string, paperLast: string }} props
 */
export function GeneralSettingsMoreSection({ paperFirst, paperLast }) {
  return (
    <GeneralSettingsSection title="More" introKey="general-more">
      <Stack spacing={0} className={shared.preferenceSectionRows}>
        <Paper elevation={0} className={paperFirst}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems={{ xs: 'stretch', sm: 'center' }}
            className={shared.preferenceRowLayout}
          >
            <SettingsRowLabelBlock title="Log Out" hideDescription />
            <Button variant="outlined" size="small" onClick={() => {}}>
              Log Out
            </Button>
          </Stack>
        </Paper>
        <Paper elevation={0} className={paperLast}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems={{ xs: 'stretch', sm: 'center' }}
            className={`${shared.preferenceRowLayout} ${styles.dangerRow}`}
          >
            <SettingsRowLabelBlock title="Delete Account" hideDescription />
            <Button variant="outlined" size="small" color="error" onClick={() => {}}>
              Delete
            </Button>
          </Stack>
        </Paper>
      </Stack>
    </GeneralSettingsSection>
  )
}
